exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-contact-tsx": () => import("./../../../src/pages/contact.tsx" /* webpackChunkName: "component---src-pages-contact-tsx" */),
  "component---src-pages-free-proposal-tsx": () => import("./../../../src/pages/free-proposal.tsx" /* webpackChunkName: "component---src-pages-free-proposal-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-template-blog-page-tsx": () => import("./../../../src/template/blogPage.tsx" /* webpackChunkName: "component---src-template-blog-page-tsx" */)
}

